// test12
(12 && 0);
